import { GetterTree } from "vuex";
import { MasmenState } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<MasmenState, RootState> = {};

export default getters;
